import * as React from 'react'
import { Box } from '@mui/material'
import { ButtonIconSeeker } from "@ui-seeker/core"

import { useAdminSkuTable } from "../../@hooks"


export default function editColumn() {
    return {
        name: "skuID", label: "Edit",
        options: {
            headerAlign: "center",
            filter: false,
            sort: false,
            customBodyRowRenderLite: value => <EditCell skuID={value} />
        }
    }
}

const EditCell = ({ skuID }) => {
    const { isLoading, handleClickEdit } = useAdminSkuTable(skuID)
    let className = ""
    if (isLoading)
        className = "is-loading"

    return <Box display="flex" justifyContent="center" className={className}>
        <ButtonIconSeeker icon="pen-nib" onClick={handleClickEdit} />
    </Box>
}